"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtifactDescriptionError = void 0;
class ArtifactDescriptionError extends Error {
    constructor(message) {
        super(message);
        // Preserve error name in the stack trace
        this.name = this.constructor.name;
    }
}
exports.ArtifactDescriptionError = ArtifactDescriptionError;
//# sourceMappingURL=artifact-description-error.js.map